import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import AuthProvider from './AuthProvider';
import AuthService from '../../../services/AuthService';
import UnauthorizedRoutes from './UnauthorizedRoutes';
import RedirectParams from './RedirectParams';
import AuthorizedRoutes from './AuthorizedRoutes';
import LocationTracker from './LocationTracker';
import TopBar from '../layout/TopBar';
import { store } from '../../../store';
import { LikeMindedApp } from './LikeMindedApp';
import SectionInfoSideDrawer from '../../components/section-info-side-drawer';
import AppDrawer from './AppDrawer';

const AppRouter = () => {
  return (
    <Router>
      <Route
        render={() => {
          return (
            <>
              <Provider store={store}>
                <RedirectParams>
                  {!AuthService.hasAuthInStorage() ? (
                    <UnauthorizedRoutes />
                  ) : (
                    <>
                      <LikeMindedApp />
                      <AuthProvider>
                        <TopBar />
                        <AuthorizedRoutes />
                        <AppDrawer />
                        <SectionInfoSideDrawer />
                      </AuthProvider>
                    </>
                  )}
                  <LocationTracker />
                </RedirectParams>
              </Provider>
            </>
          );
        }}
      />
    </Router>
  );
};

export default AppRouter;
